import axios from '@/axios'

export default {
  getExpenseCategory({ commit }, payload) {
    const { limit, page, order, search } = payload
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    return new Promise(async (resolve, reject) => {
      await axios
        .get('expense-category', {
          params: {
            limit,
            page,
            order,
            search
          }
        })
        .then(function(response) {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          commit('SET_STATE', {
            action: 'expense_category',
            data: response.data.data
          })
          commit('SET_STATE', {
            action: 'total',
            data: response.data.totalCount
          })
          commit('SET_STATE', {
            action: 'FilteredCount',
            data: response.data.filteredCount
          })
          resolve({
            data: response.data.data,
            FilteredCount: response.data.filteredCount,
            total: response.data.totalCount
          })
        })
        .catch(function(error) {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          reject(error.message)
        })
    })
  },
  insert({ commit }, payload) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    return new Promise(async (resolve, reject) => {
      await axios
        .post('expense-category', payload)
        .then(res => {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          resolve({
            data: res.data.data,
            message: res.data.message
          })
        })
        .catch(err => {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          const message = Object.keys(err.response.data.meta).length ? Object.values(err.response.data.meta)[0] : err.response.data.message
          reject({
            errors: Object.values(err.response.data.meta),
            message
          })
        })
    })
  },
  delete({ commit }, id) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    return new Promise(async (resolve, reject) => {
      await axios
        .delete(`/expense-category/${id}`)
        .then(res => {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          resolve({
            data: res.data,
            message: res.data.message
          })
        })
        .catch(err => {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          const message = Object.keys(err.response.data.meta).length ? Object.values(err.response.data.meta)[0] : err.response.data.message
          reject({
            message
          })
        })
    })
  },
  get(_, id) {
    return new Promise(async (resolve, reject) => {
      await axios
        .get(`expense-category/${id}`)
        .then(res => {
          resolve({
            data: res.data,
            message: res.data.message
          })
        })
        .catch(err => {
          const message = Object.keys(err.response.data.meta).length ? Object.values(err.response.data.meta)[0] : err.response.data.message
          reject({
            message
          })
        })
    })
  },
  update({ commit }, { id, data }) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    return new Promise(async (resolve, reject) => {
      await axios
        .put(`/expense-category/${id}`, data)
        .then(res => {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          resolve({
            data: res.data,
            message: res.data.message
          })
        })
        .catch(err => {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          const message = Object.keys(err.response.data.meta).length ? Object.values(err.response.data.meta)[0] : err.response.data.message
          reject({
            errors: Object.values(err.response.data.meta),
            message
          })
        })
    })
  },
  async bulkDelete({ commit }, { ids }) {
    const accessToken = localStorage.getItem('accessToken')
    const options = {
      method: 'DELETE',
      url: '/expense-category',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer  ${accessToken}`
      },
      data: { ids }
    }
    try {
      commit('SET_STATE', {
        action: 'loading',
        data: true
      })
      const { data } = await axios.request(options)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return { message: data.message }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const message = Object.keys(err.response.data.meta).length ? Object.values(err.response.data.meta)[0] : err.response.data.message
      return Promise.reject({ message })
    }
  }
}
